import React, { useMemo, useCallback } from 'react';
import keys from 'lodash/keys';
import map from 'lodash/map';

import find from 'lodash/find';
import isArray from 'lodash/isArray';

import { ID } from '../../../../types';

import {
  MultiSelectExtendedDataType,
  MultiSelectChangeCallbackType
} from '../../../../helpers/MultiSelect/types';

import { useTranslate } from '../../../../common/hooks/useTranslate';

import { MultiSelect } from '../../../../helpers/MultiSelect';

import { teamClientI18nTextStatuses } from '../../teamsConstants';

interface TeamClientStatusesMultiSelectProps {
  value: ID[];
  autoFocus?: boolean;
  onChange: (value: ID[]) => void;
}

function TeamClientStatusesMultiSelect({
  value,
  autoFocus,
  onChange
}: TeamClientStatusesMultiSelectProps) {
  const { t } = useTranslate();
  const data = useMemo<MultiSelectExtendedDataType[]>(() => {
    const statuses = keys(teamClientI18nTextStatuses);

    return map(statuses, (status) => ({
      value: status,
      label: t(teamClientI18nTextStatuses[status])
    }));
  }, [t]);

  const multiSelectValue = useMemo<MultiSelectExtendedDataType[]>(() => {
    return isArray(value)
      ? value.map((item) => find(data, ['value', item]))
      : [];
  }, [value, data]);

  const handleChange = useCallback<MultiSelectChangeCallbackType>(
    (value: MultiSelectExtendedDataType) => {
      onChange(isArray(value) ? value.map((item) => item.value) : []);
    },
    [onChange]
  );

  return (
    <MultiSelect
      inputWrapperClassName="block"
      onChange={handleChange}
      value={multiSelectValue}
      multi={true}
      isSearchable={true}
      data={data}
      classNamePrefix="av_multi_select"
      autoFocus={autoFocus}
    />
  );
}

export default TeamClientStatusesMultiSelect;
